import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssProvider } from "@citi-icg-172888/icgds-react";
import { DataProvider } from "./services/context/DataContext";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CssProvider>
      <ThemeProvider>
        <DataProvider>
          <BrowserRouter basename={"/global"}>
            <App />
          </BrowserRouter>
        </DataProvider>
      </ThemeProvider>
    </CssProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
